import { getCWRedirectUrl } from "utils/helper";

export const HEALTH_APP_STATUS_CONTENT = {
  pageTitle: "You did it!",
  pageHeadingText: "",
  footerButtonText: "Back to Dashboard",
  urlText: "Return to Dashboard",
  url: getCWRedirectUrl("/onboarding_checklist"),
};

export const HEALTH_APP_UPSELL_STATUS_CONTENT = {
  pageTitle: "You did it!",
  pageHeadingText: "We know that was a lot. Here's what you can expect:",
  footerButtonText: "Back to Benefits",
  urlText: "Back to Benefits",
  url: getCWRedirectUrl("/benefits/offer"),
};
